@import "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat:wght@700&display=swap";

/* src/app/forms/produtos/amazon/amazon-schema-creator/amazon-schema-creator.component.scss */
body,
input,
button,
select,
mat-form-field {
  font-family: "Lato", sans-serif;
}
h1,
h2,
h3,
.field-title,
.mat-vertical-stepper-header {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}
.integration-container {
  display: flex;
  font-family: sans-serif;
  flex-direction: column;
  height: 100%;
  flex-direction: column;
  overflow-y: auto;
}
.integration-body-container {
  max-height: 100%;
  overflow-y: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.mat-vertical-stepper {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}
.mat-vertical-stepper .mat-vertical-stepper-header {
  background-color: #f0f0f0;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}
.mat-vertical-stepper .mat-step {
  padding: 16px;
}
mat-form-field {
  width: 100%;
}
.mat-drawer-content {
  overflow: hidden !important;
}
.stepper-content-container {
  padding: 16px;
}
.field-section:not(:empty) {
  margin-bottom: 10px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  background: #f6f6f6;
  border-radius: 4px;
  padding: 10px;
}
.field-section:empty {
  background: #e0e0e0;
  opacity: 0.5;
}
.field-title {
  font-weight: bold;
  font-size: 120%;
  font-family: sans-serif;
}
.field-title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}
.mat-step-text-label {
  font-size: 100%;
}
body,
mat-form-field,
.mat-step-text-label {
  font-family: sans-serif;
}
.fields-detail {
  margin-bottom: 5px;
}
.margin-top {
  margin-top: 10px;
}
.custom-header {
  font-weight: bold;
  font-size: 120%;
}
.product-item-image {
  margin-top: 20px;
  margin-bottom: 20px;
}
.uploadFile {
  background-color: #000000 !important;
}
.viewJson {
  background-color: #c6d0ce !important;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=amazon-schema-creator.component.css.map */
